import React, { useState } from "react";
import { Table, Input, Button, Modal, Form, Upload, Select } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import useResources from "../../../hooks/AdminDashboard/useResources";

function Resources() {
	const {
		setSearchTerm,
		filteredResources,
		courses,
		isModalVisible,
		modalType,
		selectedResource,
		form,
		showModal,
		handleModalConfirm,
		handleModalCancel,
	} = useResources();

	// const [selectedFile, setSelectedFile] = useState(null);
	const [materials] = useState([{ key: Date.now() }]);
	const { Option } = Select;

	const columns = [
		{ title: "Resource Name", dataIndex: "name", key: "name" },
		{
			title: "Course Name",
			dataIndex: ["courseId", "name"], // Accessing the populated field
			key: "courseName",
		},
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<span className="space-x-2">
					<Button
						icon={<DeleteOutlined />}
						onClick={() => showModal("delete", record)}
						danger
						// className="bg-red-500 hover:bg-red-600 text-white"
					/>
				</span>
			),
		},
	];

	// const handleImageChange = (event) => {
	// 	if (event.target.files && event.target.files.length > 0) {
	// 		const file = event.target.files[0];
	// 		setSelectedFile(URL.createObjectURL(file)); // Create a URL for the uploaded file
	// 		const fileName = Date.now() + ".jpg";
	// 	}
	// };

	const renderFormContent = () => {
		// Function to add a new resource card
		// const addResource = () => {
		// 	setMaterials([...materials, { key: Date.now() }]);
		// };

		// // Function to remove a resource card
		// const removeResource = (key) => {
		// 	setMaterials(materials.filter((resource) => resource.key !== key));
		// };

		// Function to detect file type
		const detectFileType = (file) => {
			if (!file) return "Unknown";
			const type = file.type.split("/")[0];
			switch (type) {
				case "image":
					return "Image";
				case "video":
					return "Video";
				case "application":
					return "Document";
				default:
					return "Other";
			}
		};

		switch (modalType) {
			case "edit":
			case "add":
				return (
					<>
						<Form.Item
							name="courses"
							label="Courses"
							rules={[
								{
									required: true,
									message:
										"You need to pick a course to assign the resource to",
								},
							]}
						>
							<Select placeholder="Select a course">
								{courses.map((course) => (
									<Option key={course._id} value={course._id}>
										{course.name}
									</Option>
								))}
							</Select>
						</Form.Item>
						{materials.map((resource) => (
							<div
								key={resource.key}
								className="border p-4 rounded-lg shadow-md bg-gray-50 mb-4 relative"
							>
								<Form.Item
									name={`files-${resource.key}`}
									label="File Upload"
									rules={[
										{
											required: true,
											message: "Please upload a file",
										},
									]}
									getValueFromEvent={(e) => e.fileList}
								>
									<Upload
										beforeUpload={() => false}
										listType="text"
										accept="*/*"
										multiple
									>
										<input
											type="file"
											accept="*/*"
											className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-100 focus:outline-none file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-indigo-100 file:text-indigo-700 hover:file:bg-indigo-200"
											onChange={(e) => {
												const file = e.target.files;
												const fileType =
													detectFileType(file);
												alert(
													`Detected file type: ${fileType}`
												);
											}}
											multiple
										/>
									</Upload>
								</Form.Item>
							</div>
						))}
					</>
				);

			case "view":
				return (
					<div className="p-4">
						<p className="text-sm font-medium text-gray-700">
							<strong>Resource Name:</strong>{" "}
							{selectedResource?.name || "N/A"}
						</p>
						<p className="text-sm font-medium text-gray-700">
							<strong>Course ID:</strong>{" "}
							{selectedResource?.courseId || "N/A"}
						</p>
						<p className="text-sm font-medium text-gray-700">
							<strong>File URL:</strong>{" "}
							{selectedResource?.fileUrl || "N/A"}
						</p>
						<p className="text-sm font-medium text-gray-700">
							<strong>Type:</strong>{" "}
							{selectedResource?.type || "N/A"}
						</p>
					</div>
				);
			case "delete":
				return (
					<p className="text-sm text-gray-700">
						Are you sure you want to delete this resource? This
						action cannot be undone.
					</p>
				);
			default:
				return null;
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">Resources </h2>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
				<Input.Search
					placeholder="Search by resource title..."
					onChange={(e) => setSearchTerm(e.target.value)}
					className="w-full"
				/>
				<Button
					type="primary"
					icon={<PlusOutlined />}
					onClick={() => showModal("add")}
					className="w-full bg-blue-500 hover:bg-blue-600"
				>
					Add Resource
				</Button>
			</div>

			<Table
				columns={columns}
				dataSource={filteredResources}
				rowKey="_id"
				pagination={{ position: ["bottomRight"] }}
				className="w-full"
			/>

			<Modal
				title={`${
					modalType.charAt(0).toUpperCase() + modalType.slice(1)
				} Category`}
				open={isModalVisible}
				onCancel={handleModalCancel}
				footer={null} // Custom footer to handle form submission
			>
				<Form
					layout="vertical"
					onFinish={handleModalConfirm} // Handle submission
					initialValues={
						modalType === "edit" && selectedResource
							? {
									title: selectedResource.title,
									description: selectedResource.description,
							  }
							: {}
					}
					form={form}
					encType="multipart/form-data"
				>
					{renderFormContent()}
					<Form.Item>
						<Button type="primary" htmlType="submit">
							{modalType === "delete" ? "Confirm" : "Submit"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
}

export default Resources;
